import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";
import variableEffects from "@/base/global/variables/figma.effects.json";

export const tabsThemeToken: any = {
  //=================== COLOR =========================/
  inkBarColor: variableColors["ColorFigmaComplementaryBlue50"],
  itemActiveColor: variableColors["ColorFigmaComplementaryBlue50"],
  itemColor: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorBorder: variableColors["ColorFigmaNeutralGrayscaleGray40"],
  itemHoverColor: variableColors["ColorFigmaComplementaryBlue50"],
  itemSelectedColor: variableColors["ColorFigmaComplementaryBlue50"],

  //=================== FONT =========================/
  titleFontWeight: variableTypography["BodyH300FontWeight"],
  titleFontSize: variableTypography["BodyH300FontSize"],
  titleFontSizeLG: variableTypography["BodyH400FontSize"],
  titleFontSizeSM: variableTypography["BodyH200FontSize"],

  //=================== SIZE =========================/
  lineWidthBold: 3,
  margin: 64,
  horizontalItemGutter: 40,

  boxShadow: variableEffects["BoxShadowElevation2"],
};
